import React from 'react';
import {Link} from 'react-router-dom';
import Message from '../message/Message';
import PropTypes from 'prop-types';
import {TimelineLite, Power4} from 'gsap';
import root from 'window-or-global';
import {generateRoutePath} from 'epic-common/src/route';

class HeroBlock extends React.Component {
    constructor(props) {
        super(props);
        this.characterCircleToAnimateIn = '#static-characters';
    }
    static propTypes = {
        data: PropTypes.object,
        isSubscribed: PropTypes.bool
    }

    componentDidMount() {
        if (root._epicGamesNav.browser.chrome) {
            root.document.querySelector('#static-characters').style.display = 'none';
            this.characterCircleToAnimateIn = '#characters';
            this.mouseXRay();
        }
        this.heroBlockAnimation();
    }
    mouseXRay = () => {
        // Constants
        const circleWidth = 677;
        const $characters = root.document.querySelector('#characters');
        const originX = $characters.style.width / 2;
        const originY = $characters.style.height / 2;
        let bIsInBox = false;
    
        // Variables that need to save between each tick
        let currentX = originX;
        let currentY = originY;
        let desiredX = originX;
        let desiredY = originY;
        let intervalFun = null;
        let bIsGoingHome = false;
        let interpSpeedAlpha = 0;
        const interpSpeedAccelTime = 1;
        const goingHomeInterpSpeed = 1;
        const InBoxInterpSpeed = 3;
        let interpSpeed = InBoxInterpSpeed;
    
        const lerp = (a, b, alpha) => {
            return a + alpha * (b - a);
        };
    
        const interpEaseIn = (a, b, alpha, exp) => {
            const modifiedAlpha = Math.pow(alpha, exp);
            return lerp(a, b, modifiedAlpha);
        };
    
        const moveCircle = () => {
            const deltaSeconds = 0.033;
    
            if (bIsGoingHome && interpSpeedAlpha < 1) {
                interpSpeedAlpha += deltaSeconds * interpSpeedAccelTime;
                interpSpeedAlpha = Math.min(interpSpeedAlpha, 1);
                interpSpeed = interpEaseIn(0, goingHomeInterpSpeed, interpSpeedAlpha, 3);
            }
    
            // Interpolate smoothly to new location, slowing down when we near desiredXY
            const DistX = desiredX - currentX;
            const DistY = desiredY - currentY;
            const DistXYsq = DistX * DistX + DistY * DistY;
            if (DistXYsq < 2.0) {
                currentX = desiredX;
                currentY = desiredY;
    
                if (!bIsInBox) {
                    if (bIsGoingHome) {
                        clearInterval(intervalFun);
                        bIsGoingHome = false;
                    } else {
                        desiredX = originX;
                        desiredY = originY;
                        bIsGoingHome = true;
                        interpSpeedAlpha = 0;
                    }
                }
            } else {
                currentX += DistX * (Math.max(Math.min(deltaSeconds * interpSpeed, 1), 0));
                currentY += DistY * (Math.max(Math.min(deltaSeconds * interpSpeed, 1), 0));
            }
            $characters.style.webkitMaskPositionX = `${currentX - circleWidth / 2}px`;
            $characters.style.webkitMaskPositionY = `${currentY - circleWidth / 2}px`;
        };
        const $logo = root.document.querySelector('#logo');
        $logo.addEventListener('mouseenter', (e) => {
            clearInterval(intervalFun);
            bIsGoingHome = false;
            bIsInBox = true;
            desiredX = e.pageX;
            desiredY = e.pageY;
            interpSpeed = InBoxInterpSpeed;
            intervalFun = setInterval(moveCircle, 33);
        })
        $logo.addEventListener('mousemove', (e) => {
            desiredX = e.pageX;
            desiredY = e.pageY;
        })
        $logo.addEventListener('mouseleave', (e) => {
            bIsInBox = false;
        });
    };
    heroBlockAnimation = () => {
        const $box = root.document.querySelector('#co-creators');
        const $box2 = root.document.querySelector('#present');
        const $box3 = root.document.querySelector('#logo');
        const $box4 = root.document.querySelector('#access');
        const $box5 = root.document.querySelector('.landing-beta-sign-up');
        const $cssCircle = root.document.querySelector(this.characterCircleToAnimateIn);
        const tl = new TimelineLite({ onComplete: this.mouseXRay });
    
        tl.from($box, 1, { y: '+=40', autoAlpha: 0, ease: Power4.easeInOut })
            .from($box2, 1, { y: '+=40', autoAlpha: 0, ease: Power4.easeInOut }, '-=0.9')
            .from($box3, 1, { y: '+=40', autoAlpha: 0, ease: Power4.easeInOut }, '-=0.9')
            .from($box4, 1, { y: '+=40', autoAlpha: 0, ease: Power4.easeInOut }, '-=0.9')
            .from($box5, 1, { y: '+=40', autoAlpha: 0, ease: Power4.easeInOut }, '-=0.9')
            .from($cssCircle, 1, { y: '+=40', autoAlpha: 0, ease: Power4.easeInOut }, '-=0.9');
    };
    
    render() {
        // const homeLink = generateAppPath('/home');
        const {data, isSubscribed} = this.props;

        return (
            <section className="hero-block">
                <div id="characters">
                    <img src={data.bgImage} alt='charator' />
                </div>
                <div id="static-characters" />
                <div className="mobile-characters" />
                <h4 id="co-creators">{data.subTitle1}</h4>
                <h5 id="present">{data.subTitle2}</h5>
                <img alt="logo" src={data.imageTitle} id="logo" />
                <h3 id="access">{data.subTitle3}</h3>
                <div className="landing-beta-sign-up">
                    {
                        isSubscribed ?
                            <div className="signed-up"><Message code="epic.spyjinx.signed.up" /></div>
                            :
                            <div>
                                <Link to={generateRoutePath('/beta-sign-up')} className="btn beta-sign-up">{data.buttonText}</Link>
                            </div>
                    }
                    
                </div>
                <div className="scroll-down">
                    <i className="fa fa-angle-down" />
                </div>
            </section>
        );
    }
}

export default HeroBlock;
